import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { OrderDetailAttributes } from '@albatrosdeveloper/ave-models-package';

/**
 * Customer Cell Renderer
 *
 * Renders customer code (bold) and customer name on separate lines
 *
 * @example
 * ```typescript
 * {
 *   field: 'shipToExternalKeyCode',
 *   headerName: 'Cliente',
 *   cellRenderer: CustomerCellRendererComponent,
 *   minWidth: 200
 * }
 * ```
 */
@Component({
  selector: 'app-customer-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <b class="f-10">{{ params.data?.shipToExternalKeyCode }}</b><br>
    <span class="font-descrip">{{ params.data?.shipToName }}</span>
  `,
})
export class CustomerCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;
}
